import {useFeatureIsOn} from "@growthbook/growthbook-react";
import {createContext, useContext} from "react";

import {useGuideState} from "@khan/guide-state";
import {RequestInfo} from "@khan/shared-core";

import {useConfigSupportsImageInput} from "./use-config-supports-image-input.ts";

export const ImageInputSupportedContext: React.Context<boolean> =
    createContext(true);

/**
 * A hook to determine if image input is supported in the current context.
 *
 * @returns A boolean indicating if image input is supported.
 */
export function useSupportImageInput(): boolean {
    const hasAcknowledgedGuide = useGuideState("hasAcknowledgedGuide");
    const imageInputSupportedInContext = useContext(ImageInputSupportedContext);
    const isNotMobileApp = !RequestInfo.isMobileApp;
    const configSupportsImageInput = useConfigSupportsImageInput();

    return (
        useFeatureIsOn("images-in-images-out") &&
        isNotMobileApp &&
        hasAcknowledgedGuide &&
        imageInputSupportedInContext &&
        configSupportsImageInput
    );
}
